module.exports = __webpack_public_path__ + "images/element-icons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 945
// module chunks = 2